
import Vue from "vue";
import Icon from "@/assets/icons/Icon.vue";

export default Vue.extend({
  components: {
    Icon,
  },
  computed: {
    esRutaEspecial() {
      // Puedes definir todas las rutas especiales aquí (como partners)
      return ["/pre-columbia", "/landingProgramaIngles", "/openday2024"].includes(this.$route.path);
    },
  },
  name: "Footer",
  data: () => ({
    font: "",
    font_copy: "",
    size_button: "",
    img_footer: "",
    ft: "",
    wd: "",
    mxh: "",
    min_width_img_btn: "",
    size_icon: "30",
    mt3: "",
    padding: "",

    icons: [
      "mdi-facebook",
      "mdi-linkedin",
      "mdi-youtube",
      "mdi-instagram",
      "mdi-twitter",
    ],
    footer_links: [
      {
        name: "Inicio",
        route: "/home",
      },
      {
        name: "Sobre Columbia",
        route: "/por-que-columbia",
      },
      {
        name: "Oferta Educativa",
        route: "/educative_offer",
      },
      {
        name: "Partners",
        route: "/partners",
      },
      {
        name: "Profesionales Columbia",
        route: "/professionals",
      },
      {
        name: "Portal del Alumno",
        route: "/portal",
      },
      // {
      //   name: "Blog",
      //   route: "",
      // },
      {
        name: "Portal de transparencia",
        route: "/portal-de-transparencia",
      },
    ],
  }),
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    onResize() {
      if (window.innerWidth > 1650) {
        this.font = "16px";
        this.font_copy = "11px";
        this.ft = "3rem";
        this.img_footer = "img_footer";
        this.wd = "270px !important";
        this.mxh = "50px !important";
        this.min_width_img_btn = "160px";
        this.size_icon = "50";
        this.mt3 = "mt-3";
        this.padding = "pa-12";
      } else {
        this.font = "12px";
        this.font_copy = "11px";
        this.ft = "";
        //this.img_footer = "img_footer2"
        this.wd = "";
        this.mxh = "";
        this.min_width_img_btn = "";
        this.size_icon = "30";
        this.mt3 = "";
        this.padding = "";
      }
    },
  },
});
